export default __webpack_public_path__ + "static/media/007-helmet.79c5c431.png";